export default "__VITE_ASSET__Dfmik6OA__"